export default {
  pendingMod: "Pending Approval List",
  historyMod: "History Modification List",
};
